export const WIDTH_PER_PLAYER = 100;
